import React from 'react';
import {
  DataGrid,
  GridLogicOperator,
  gridClasses,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import { makeStyles } from '@mui/styles';
import { alpha, styled } from '@mui/material/styles';

const useStyles = makeStyles({
  columnsButton: {
    scale: 1.25,
    padding: '8px',
  },
});

function CustomToolbar(name) {
  const classes = useStyles();
  const newdata = JSON.parse(localStorage.getItem('myTabledata')) !== null
    ? JSON.parse(localStorage.getItem('myTabledata')).ProductReturnSerialList
    : null;
  const exportData = newdata !== null || undefined
    ? newdata?.map((row) => ({
      ...row,
      TrackingNo: row.TrackingNo?.toString(),
    }))
    : null;
  return (
    <div className="container-fluid">
      <div className="row" id="table_feature">
        <GridToolbarContainer>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarColumnsButton className={classes.columnsButton} />
          </div>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarDensitySelector className={classes.columnsButton} />
          </div>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarFilterButton className={classes.columnsButton} />
          </div>
          <div className="col-xs-8 col-sm-6 col-md-4 col-lg-2">
            <GridToolbarExport
              printOptions={{ disableToolbarButton: true }}
              csvOptions={{
                fileName: name,
              }}
              exportdata={exportData}
              type="string"
              className={classes.columnsButton}
            />
          </div>
          <div id="quick_search">
            <GridToolbarQuickFilter />
          </div>
        </GridToolbarContainer>
      </div>
    </div>
  );
}

const ODD_OPACITY = 0.2;
const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[200],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY
            + theme.palette.action.selectedOpacity
            + theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));

const CustomDataGrid = ({ name, tableData, column, rowSelection }) => (
  <StripedDataGrid
    sx={{ borderRadius: '20px' }}
    columns={column}
    rows={tableData?.map((row, index) => ({ ...row, id: index + 1 }))}
    getRowId={(row) => row.id}
    components={{ Toolbar: () => CustomToolbar(name) }}
    checkboxSelection={rowSelection !== false}
    getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd')}
    initialState={{
      filter: {
        filterModel: {
          items: [],
          quickFilterLogicOperator: GridLogicOperator.Or,
        },
      },
    }}
  />
);

export default CustomDataGrid;
